const current = [
  {
    path: '/hr/management/current/register',
    component: () => import('@/page/hr/management/current/Register.vue'),
    meta: {
      name: '인력추가',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/hr/management/current/detail/:id',
    component: () => import('@/page/hr/management/current/Detail.vue'),
    meta: {
      name: '상세페이지',
      isActive: false,
      isBread: true,
    },
  },
];

export default current;
